import {  useEffect, useState } from "react";
import _find from 'lodash/find';
import { useLocation } from "react-router-dom";
import { useParams } from 'react-router-dom';
import { KoBadge, KoDP, KoRichTextEditorReadOnly,  KoInput, KoText, KoTitle, KoButton, KoModal, KoLoader } from "packages";
import KoIcon from '@kwapio/icons';
import { KO_DEVELOPMENT } from "shared/types/development";
import { ChatAPI } from "./chat.service";
import {  getTimeStamp } from "shared/utils";
import styles from './contacts.module.scss';
import { useDispatch } from "react-redux";
import { setRecipient } from "shared/store/chatUserSlice";


function KoContacts({ onChange, users, groups }) {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const lastSegment = pathSegments[pathSegments.length - 1];

  const dispatch = useDispatch();
  useEffect(() => {
    getContacts();
  }, [lastSegment]);
  
  let { roomId } = useParams();

  const [isContactOpen, setIsContactOpen] = useState(false);
  const [searchList, setSearchList] = useState();
  const [queryText, setQueryText] = useState();
  const [activeChat, setActiveChat] = useState('Recent');
  const [tagFilter, setTagFilter] = useState('All');
  const [contactsFullList, setContactsFullList] = useState();
  const [queryTextModal, setQueryTextModal] = useState('');
  const [isLoading, setLoading] = useState(false);
  const getIcon = (type) => {
    let issue = _find(KO_DEVELOPMENT, function(o) { return o.value === type; });
    return issue?.icon;
  };

  const getContacts = async(q) => {
    setLoading(true);
    ChatAPI.getRecentChats(q).then(
      (data) => {
        setLoading(false);
        setSearchList(data['rooms']);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const getAllContacts = async(q) => {
    setLoading(true);
    ChatAPI.getRoomsUsers(q).then(
      (data) => {
        setLoading(false);
        setContactsFullList(data);
      },
      (err) => {
        setLoading(false);
      }
    );
  };


  const searchText = (e) => {
    const val = e.target.value;
    let q = { search: val };
    if (val) {
      setQueryText(val);
      setSearchList();
      getContacts(q);
    } else {
      setQueryText('');
    }


  };

  const searchTextModal = (e) => {
    const val = e.target.value;
    let q = { search: val };
    if (val) {
      setQueryTextModal(val);
      getAllContacts(q);
    } else {
      setQueryTextModal('');
    }


  };


  const onChangeChatUser = (item, source) => {
    setQueryText('');
    let recipient = { ...item, source };
    dispatch(setRecipient(recipient));
    
  };

  const onOpenContact = (row) => {
    setIsContactOpen(true);
    getAllContacts(row);
  };

  return (
    <>
      { isLoading && <KoLoader/>}
      <div className={styles.wrapper}>
        <div className={styles.title}>
          <KoTitle text='Chats' level={4} />
          <KoButton icon={<KoIcon name='PlusOutlined' />} onClick={() => onOpenContact(true)} />
        </div>
        <div className={styles.search}>
          <KoInput allowClear onChange={searchText}
            value={queryText}
            variant="filled" size="large"
            addonBefore={<KoIcon name='SearchOutlined' />} placeholder='Search user or group or ticket' />
        </div>
        <div className={styles.filters}>
          <div className={`${styles.tag} ${activeChat === 'Recent' ? styles.active : ''}`} onClick={() => setActiveChat('Recent')} ><KoText text='Recent' /> </div>
          <div className={`${styles.tag} ${activeChat === 'Peoples' ? styles.active : ''}`} onClick={() => setActiveChat('Peoples')} ><KoText text='Peoples' /> </div>
          <div className={`${styles.tag} ${activeChat === 'Groups' ? styles.active : ''}`} onClick={() => setActiveChat('Groups')} ><KoText text='Groups' /> </div>
          <div className={`${styles.tag} ${activeChat === 'Tickets' ? styles.active : ''}`} onClick={() => setActiveChat('Tickets')} ><KoText text='Tickets' /> </div>
        </div>
        <div className={styles.contacts}>
          <ul>
            {queryText && searchList?.users?.map((item, i) =>
              <li className={item.userId?.toLowerCase().includes(queryText) ? styles.searchActive : ''} key={i}
                onClick={() => onChangeChatUser(item, 'users')}>
                <div className={styles.chatType}>
                  <KoBadge size={'default'} offset={[-4, 25]} dot={true} color={!item?.isOnline ? `var(--palette-success-main)` : `var(--palette-error-main)`} >
                    {item?.profile?.logo ? <KoDP fallback='UserFilled' className={styles.icon} width={26} height={26} logo={item?.profile?.logo} />
                      : <KoIcon name='UserFilled' className={styles.icon} width={26} height={26} />}
                  </KoBadge>
                  <div className={styles.profileMessage}>
                    <div className={styles.profileName}>
                      <KoText className={styles.name} text={item.profile?.firstName + ' ' + item.profile?.lastName} />
                      {item?.lastMessage?.dateTime && <KoText className={styles.time} text={getTimeStamp(item?.lastMessage?.dateTime)} />}
                    </div>
                    <div className={styles.message}>
                      <KoRichTextEditorReadOnly text={item?.email} initialValues={item?.lastMessage?.content} from='contacts' />
                    </div>
                  </div>
                </div>
              </li>
            )}
            {queryText && searchList?.groups?.map((item, i) =>
              <li className={item.groupId?.toLowerCase().includes(queryText) ? styles.searchActive : ''} key={item.groupId}
                onClick={() => onChangeChatUser(item, 'groups')}>
                <div className={styles.chatType}>
                  {item?.logo?.length > 0 ? <KoDP fallback='GrpupsFilled' className={styles.icon} width={26} height={26} logo={item?.logo} /> :
                    <KoIcon name='GrpupsFilled' className={styles.icon} width={26} height={26} />}
                  <div className={styles.profileMessage}>
                    <div className={styles.profileName}>
                      <KoText className={styles.name} text={item.name} />
                      {item?.lastMessage?.dateTime && <KoText className={styles.time} text={getTimeStamp(item?.lastMessage?.dateTime)} />}
                    </div>
                    <div className={styles.message}>
                      <KoRichTextEditorReadOnly text={item?.email} initialValues={item.lastMessage?.content} from='contacts' />
                    </div>
                  </div>
                </div>
              </li>
            )}

            {queryText && searchList?.tickets?.map((item, i) =>
              <li className={item.ticketId?.includes(queryText.toUpperCase()) ? styles.searchActive : ''} key={i}
                onClick={() => onChangeChatUser(item, 'tickets')}>
                <div className={styles.chatType}>
                  <div className={styles.icon} >
                    {getIcon(item?.issueType)}
                  </div>
                  <div className={styles.profileMessage}>
                    <div className={styles.profileName}>
                      <KoText className={styles.name} text={item.ticketId} />
                      {item?.lastMessage?.dateTime && <KoText className={styles.time} text={getTimeStamp(item?.lastMessage?.dateTime)} />}
                    </div>
                    <div className={styles.message}>
                      <KoRichTextEditorReadOnly text={item?.summary} initialValues={item?.content} from='contacts' />
                    </div>
                  </div>
                </div>
              </li>
            )}
            {
              searchList?.length > 0 && searchList?.map((item, i) => (
                <li className={roomId === item?.userId ? styles.active : ''} key={i} onClick={() => onChangeChatUser(item, 'users')}>
                  <div className={styles.chatType}>
                    <KoBadge size={'default'} offset={[-4, 25]} dot={true} color={!item?.isOnline ? `var(--palette-success-main)` : `var(--palette-error-main)`} >
                      {item?.profile?.logo ? <KoDP fallback='UserFilled' className={styles.icon} width={26} height={26} logo={item?.senderProfile?.logo} />
                        : <KoIcon name='UserFilled' className={styles.icon} width={26} height={26} />}
                    </KoBadge>
                    <div className={styles.profileMessage}>
                      <div className={styles.profileName}>
                        <div className={styles.nameWithMessage}>
                          <KoText className={styles.name} text={item.senderProfile?.firstName + ' ' + item.senderProfile?.lastName} />
                          <div className={styles.message}>
                            <KoRichTextEditorReadOnly text='-' initialValues={item?.content} from='contacts' />
                          </div>
                        </div>
                        {item?.dateTime && <div className={styles.messageTime}>
                          <KoText className={styles.time} text={getTimeStamp(item?.dateTime)} />
                          {item?.count ? <div className={styles.unreadCount}>{item?.count}</div> : <span>&nbsp;</span>}
                        </div>}
                      </div>

                    </div>
                  </div>
                </li>
              ))
            }
          </ul>
        </div>
        <KoModal
          title={'Contacts, Groups and Tickets'}
          open={isContactOpen}
          width={'49rem'}
          centered
          onClose={() => setIsContactOpen(false)}
        >
          <div className={`${styles.contacts} ${styles.contactModal}`}>
            { isLoading && <KoLoader/>}
            <div className={styles.search}>
              <KoInput allowClear onChange={searchTextModal}
                value={queryTextModal}
                variant="filled" size="large"
                addonBefore={<KoIcon name='SearchOutlined' />} placeholder='Search user or group or ticket' />
            </div>
            <div className={styles.filters}>
              <div className={`${styles.tag} ${tagFilter === 'All' ? styles.active : ''}`} onClick={() => setTagFilter('All')} ><KoText text='All' /> </div>
              <div className={`${styles.tag} ${tagFilter === 'Peoples' ? styles.active : ''}`} onClick={() => setTagFilter('Peoples')} ><KoText text='Peoples' /> </div>
              <div className={`${styles.tag} ${tagFilter === 'Groups' ? styles.active : ''}`} onClick={() => setTagFilter('Groups')} ><KoText text='Groups' /> </div>
              <div className={`${styles.tag} ${tagFilter === 'Tickets' ? styles.active : ''}`} onClick={() => setTagFilter('Tickets')} ><KoText text='Tickets' /> </div>
            </div>
            <ul>
              {(tagFilter === 'All' || tagFilter === 'Peoples') && contactsFullList?.users?.map((item, i) =>
                <li  key={i}
                  onClick={() => {onChangeChatUser(item, 'users'); setIsContactOpen(false);}}>
                  <div className={styles.chatType}>
                    <KoBadge size={'default'} offset={[-4, 25]} dot={true} color={!item?.isOnline ? `var(--palette-success-main)` : `var(--palette-error-main)`} >
                      {item?.profile?.logo ? <KoDP fallback='UserFilled' className={styles.icon} width={26} height={26} logo={item?.profile?.logo} />
                        : <KoIcon name='UserFilled' className={styles.icon} width={26} height={26} />}
                    </KoBadge>
                    <div className={styles.profileMessage}>
                      <div className={styles.profileName}>
                        <KoText className={styles.name} text={item.profile?.firstName + ' ' + item.profile?.lastName} />
                        {item?.lastMessage?.dateTime && <KoText className={styles.time} text={getTimeStamp(item?.lastMessage?.dateTime)} />}
                      </div>
                      <div className={styles.message}>
                        <KoText className={styles.subText} text={item?.email} />
                      </div>
                    </div>
                  </div>
                </li>
              )}
              {(tagFilter === 'All' || tagFilter === 'Groups') &&  contactsFullList?.groups?.map((item, i) =>
                <li  key={item.groupId}
                  onClick={() =>{ onChangeChatUser(item, 'groups'); setIsContactOpen(false);}}>
                  <div className={styles.chatType}>
                    {item?.logo?.length > 0 ? <KoDP fallback='GrpupsFilled' className={styles.icon} width={26} height={26} logo={item?.logo} /> :
                      <KoIcon name='GrpupsFilled' className={styles.icon} width={26} height={26} />}
                    <div className={styles.profileMessage}>
                      <div className={styles.profileName}>
                        <KoText className={styles.name} text={item.name} />
                        {item?.lastMessage?.dateTime && <KoText className={styles.time} text={getTimeStamp(item?.lastMessage?.dateTime)} />}
                      </div>
                      <div className={styles.message}>
                        <KoText className={styles.subText} text={'Total ' + item?.members?.length + ' Members'} />
                      </div>
                    </div>
                  </div>
                </li>
              )}

              {(tagFilter === 'All' || tagFilter === 'Tickets') &&  contactsFullList?.tickets?.map((item, i) =>
                <li  key={i}
                  onClick={() => {onChangeChatUser(item, 'tickets'); setIsContactOpen(false);}}>
                  <div className={styles.chatType}>
                    <div className={styles.icon} >
                      <KoIcon name='BugFilled' className={styles.icon} width={26} height={26} />
                    </div>
                    <div className={styles.profileMessage}>
                      <div className={styles.profileName}>
                        <KoText className={styles.name} text={item.ticketId} />
                        {item?.lastMessage?.dateTime && <KoText className={styles.time} text={getTimeStamp(item?.lastMessage?.dateTime)} />}
                      </div>
                      <div className={styles.message}>
                        <KoText className={styles.subText} text={item?.summary} initialValues={item?.content} from='contacts' />
                      </div>
                    </div>
                  </div>
                </li>
              )}
            </ul>
          </div>
        </KoModal>
      </div>
    </>
  );
}

export default KoContacts;